export const AlertTypes = {
  ALERT_CONFIRM: "ALERT_CONFIRM",
  ALERT_CHOOSING: "ALERT_CHOOSING",
};

